// "Pause animations" in the footer (WCAG 2.2.2): stops the drifting mist on
// every page. The choice is kept in the browser; mist.js listens for
// 'dana:motion' and reads data-motion on <html>.
const STORAGE_KEY = 'dana-motion';

export function motionPaused() {
    return document.documentElement.dataset.motion === 'off';
}

export function initMotion() {
    try {
        if (localStorage.getItem(STORAGE_KEY) === 'off') document.documentElement.dataset.motion = 'off';
    } catch {
        // Storage blocked: animations run, the button still works for this page view.
    }
    const button = document.querySelector('[data-motion-toggle]');
    if (!button) return;
    button.setAttribute('aria-pressed', String(motionPaused()));
    button.addEventListener('click', () => {
        const off = !motionPaused();
        if (off) document.documentElement.dataset.motion = 'off';
        else delete document.documentElement.dataset.motion;
        button.setAttribute('aria-pressed', String(off));
        try {
            if (off) localStorage.setItem(STORAGE_KEY, 'off');
            else localStorage.removeItem(STORAGE_KEY);
        } catch {
            // See above.
        }
        document.dispatchEvent(new CustomEvent('dana:motion'));
    });
}
